module.exports = __webpack_public_path__ + "static/media/barrybonds.567cee0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/barrybonds.jpg
// module id = 23
// module chunks = 0